import { TranslateService } from '@ngx-translate/core';

export const translateOutcomeName = (
  translate: TranslateService,
  outcomeName: string
) => translate.instant(`BusinessRules_${outcomeName}`);
